import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=c5a5f17a&scoped=true&"
import script from "./BannerItem.vue?vue&type=script&lang=js&"
export * from "./BannerItem.vue?vue&type=script&lang=js&"
import style0 from "./BannerItem.vue?vue&type=style&index=0&id=c5a5f17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a5f17a",
  null
  
)

export default component.exports